<template>
  <div>
    <message :messages="messages"></message>
    <v-card>
      <v-toolbar color="grey darken-1" dark>
        <v-toolbar-title>
          <v-icon large>{{cargoIcon}}</v-icon>
          Cargo Summary
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-md-and-down">
          <v-btn flat @click="printCoverNote" v-if="canPrintCoverNote" :loading="printCNLoading">
            Print Cover Note
            <v-icon right>mdi-printer</v-icon>
          </v-btn>
          <v-btn flat @click="showComm = true">
            Communication
            <v-icon right>mdi-comment-text</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-btn icon class="hidden-lg-and-up">
          <v-menu bottom left>
            <v-btn slot="activator" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="printCoverNote" v-if="canPrintCoverNote">
                <v-list-tile-title>Print Cover Note</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="showComm = true">
                <v-list-tile-title>Communication</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">Quotation No.</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <span class="title">{{commonForm.proposalNo}}</span>
                  </v-flex>
                  <template v-if="commonInfo.premium.billPremiumPayable">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Premium Payable</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span class="title">{{commonForm.billCurr}} {{formatDisplayNumber(commonInfo.premium.billPremiumPayable)}}</span>
                    </v-flex>
                  </template>
                  <template v-if="cargoForm.siDeclared">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Declared Sum Insured</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span class="title">{{cargoForm.siCurr}} {{formatDisplayNumber(cargoForm.siDeclared)}}</span>
                    </v-flex>
                  </template>
                  <template v-if="cargoForm.siBalance">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Balance Sum Insured</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span class="title">{{cargoForm.siCurr}} {{formatDisplayNumber(cargoForm.siBalance)}}</span>
                    </v-flex>
                  </template>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">Current Status</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <span :class="currentStatusClass">{{currentStatusLabel}}</span>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">Intermediary</v-subheader>
                  </v-flex>
                  <v-flex xs6>
                    <span>{{commonForm.intermediary}} - {{queryInfo.intermediary}}</span>
                  </v-flex>
                  <template v-if="commonForm.quotationType">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Quotation Type</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <div>{{quotationType(commonForm.quotationType)}}</div>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.masterProposalNo">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Contract/Master Proposal No.</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <div>{{commonForm.masterProposalNo}}</div>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.product">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Product</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{commonForm.product}} - {{queryInfo.product}}</span>
                    </v-flex>
                  </template>
                  <template v-if="cargoForm.busCls">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Business Class</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{cargoForm.busCls}} - {{queryInfo.busCls}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.acceptDate">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Acceptance Date</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{formatDate(commonForm.acceptDate)}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.campaign">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Campaign</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{commonForm.campaign}} - {{queryInfo.campaign}}</span>
                    </v-flex>
                  </template>
                  <template v-if="commonForm.promotion">
                    <v-flex xs6>
                      <v-subheader class="queryLabel">Promotion</v-subheader>
                    </v-flex>
                    <v-flex xs6>
                      <span>{{commonForm.promotion}} - {{queryInfo.promotion}}</span>
                    </v-flex>
                  </template>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showComm" width="600px">
      <comms-log :canSendSMS="checkAccess(['cargoQuoteIFSMS'])" :canSendEmail="checkAccess(['cargoQuoteIFMail'])" @close="showComm = false"></comms-log>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { quoteStatus, appIcon } from '@/const/underwriting'
import { quotationType } from '@/const/underwriting/cargo'
import MessageMixin from '@/mixins/message'
import CommsLog from '../../shared/CommsLog'

export default {
  data() {
    return {
      printCNLoading: false,
      showComm: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    quotation() {
      return this.$store.state.agency.quotation
    },
    currentStatusLabel() {
      if (quoteStatus[this.quotation.commonInfo.statusCode]) {
        return quoteStatus[this.quotation.commonInfo.statusCode]
      } else {
        return 'Unknown Status'
      }
    },
    currentStatusClass() {
      if (this.quotation.commonInfo.statusCode === 'QD' || this.quotation.commonInfo.statusCode === 'PD' || this.quotation.commonInfo.statusCode === 'VO' || this.quotation.commonInfo.statusCode === 'NTU' || this.quotation.commonInfo.statusCode === 'CL') {
        return 'error--text'
      } else if (this.quotation.commonInfo.statusCode === 'QPA' || this.quotation.commonInfo.statusCode === 'PPA') {
        return 'warning--text'
      } else if (this.quotation.commonInfo.statusCode === 'IF' || this.quotation.commonInfo.statusCode === 'PO') {
        return 'success--text'
      } else {
        return ''
      }
    },
    canPrintCoverNote() {
      if (this.checkAccess(['cargoPrintCN'])) {
        if (this.$store.state.agency.quotationSettings.menu.printCN) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    cargoForm() {
      return this.quotation.cargoForm
    },
    commonForm() {
      return this.quotation.commonForm
    },
    commonInfo() {
      return this.quotation.commonInfo
    },
    queryInfo() {
      return this.quotation.queryInfo
    },
    cargoIcon() {
      return appIcon.CARGO
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    quotationType(value) {
      return quotationType[value]
    },
    async printCoverNote() {
      const apiUrl = this.$store.state.agency.quotationSettings.menu.printCN
      if (apiUrl) {
        try {
          this.printCNLoading = true
          const passObj = {
            proposalNo: this.commonForm.proposalNo,
            printOriginal: true,
            numberOfDuplicates: 1,
            numberOfCopies: 0
          }
          await this.$http.post(apiUrl, passObj)
          this.printCNLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.printCNLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  mounted() {
    // If Query param (if) is passed in, its coming from Inforced Proposal
    // Check comms log
    if (this.$route.query.if) {
      if (this.checkAccess(['cargoQuoteIFSMS']) || this.checkAccess(['cargoQuoteIFMail'])) {
        this.showComm = true
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    CommsLog
  }
}
</script>

<style lang="scss">
</style>
